module.exports = {"320581001":"虞山街道","320581002":"常福街道","320581003":"琴川街道","320581004":"莫城街道","320581005":"碧溪街道","320581006":"东南街道","320581101":"梅李镇","320581102":"海虞镇","320581104":"古里镇","320581105":"沙家浜镇","320581106":"支塘镇","320581107":"董浜镇","320581110":"辛庄镇","320581111":"尚湖镇","320581401":"常熟经济技术开发区","320581402":"常熟高新技术产业开发区","320581406":"常熟昆承湖管理委员会","320581407":"常熟国家大学科技园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320581.json
// module id = 969
// module chunks = 0